// Global UI state — surface toggle (Marketing / Broker / Full Offer)
// and view-depth toggle (Surface / Cube). Both are persistent across
// view changes per INTERFACE-SPECIFICATION.md §2.1.

export type Surface = 'marketing' | 'broker' | 'full_offer';
export type ViewDepth = 'surface' | 'cube';

const state = $state<{ surface: Surface; viewDepth: ViewDepth }>({
  surface: 'marketing',
  viewDepth: 'surface'
});

export const surfaceState = state;

export function setSurface(s: Surface): void {
  // MVP: only marketing is enabled. Broker / Full Offer remain greyed
  // in the toggle group and this setter is a no-op for them.
  if (s === 'marketing') state.surface = s;
}

export function setViewDepth(d: ViewDepth): void {
  state.viewDepth = d;
}
